// extracted by mini-css-extract-plugin
export default {"descOrcamento":"Orcamentos_descOrcamento__3HYgL","formOrcamento":"Orcamentos_formOrcamento__8X1Ag"};